// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2mefp","right":"styles_right__f64cI"};